import { z } from "zod";
export const IndexSchema = z.string();
